

import * as type from './mutation-type';

export default {


  /**
   * 设置页面是否显示
   * @param state
   * @param type  {Boolean}
   */
  [type.SET_TABLE_CHECK] (state,type){
    state.table_check = type;
  },


}


// WEBPACK FOOTER //
// ./src/store/mutations.js